import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { ReactComponent as Cancel } from '../assets/cancel.svg';
import { Checkbox } from "./UI";
import db from "../firebase";
import { collection, query, where, orderBy, onSnapshot } from "firebase/firestore";
import { Editor } from './Editor';

export default function Notification({saveNotification, hideNotification, projectID}) {
	const [users, setUsers] = useState([]);
	const [filteredUsers, setFilteredUsers] = useState([]);
	const [searchTerm, setSearchTerm] = useState('');
	const [usersError, setUsersError] = useState('');
	const [message, setMessage] = useState('');

	const {
		register,
		reset,
		setValue,
		handleSubmit,
		formState: { errors },
	} = useForm();

	useEffect(() => {
		const usersRef = collection(db, "users");
		const q = query(
			usersRef,
			where("project_id", "==", projectID),
			orderBy("__name__", "desc")
		);
		const unsub = onSnapshot(q, (snapshot) => {
			const projectUsers = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
			setUsers(projectUsers);
			setFilteredUsers(projectUsers);
		});
		return () => unsub();
	}, [projectID]);

	useEffect(() => {
		const filtered = users.filter(user => 
			user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
			(user.phone && user.phone.includes(searchTerm))
		);
		setFilteredUsers(filtered);
	}, [searchTerm, users]);

	const displayMessage = (text) => {
		setMessage(text);
		setTimeout(() => {
			setMessage('');
		}, 3000);
	};

	const save = async (data) => {
		const selectedUsers = Object.entries(data.users)
			.filter(([_, isSelected]) => isSelected)
			.map(([userId, _]) => userId);

		if (selectedUsers.length === 0) {
			setUsersError('Select at least one user');
			return;
		}

		data.users = selectedUsers;
		console.log(data);
		saveNotification(data);
		hideNotification();
	}

	return (
		<div className="wrapper">
			<div className="modal modal_notification">
				<div className="header">
					<h2>Send notification</h2>
					<div className="cancel" onClick={hideNotification}>
						<Cancel/>
						Close
					</div>
				</div>

				<form onSubmit={handleSubmit(save)}>
					<div className="flex_top">
						<div className="modal_notification__left">
							<h3>SMS</h3>
							<input type="text"  {...register("sms")} />
							<div className="error">{errors["sms"] ? errors["sms"].message : '' }</div>

							<h3>Email</h3>
							<label className="label">Subject</label>
							<input type="text" {...register("email[subject]")} />

							<label className="label">Body</label>
							<Editor
								type=""
								value=""
								templates={[]}
								register={register}
								registerName={"email[html]"}
								setValue={setValue}
							/>
						</div>

						<div className="modal_notification__right">
							<h3>Select users</h3>
							<input 
								type="text" 
								placeholder="Search by name or phone number" 
								value={searchTerm}
								onChange={(e) => setSearchTerm(e.target.value)}
								className="search-input"
							/>
							<div className="users">
								{filteredUsers.map(user =>
									<div className="user" key={user.id}>
										<div>
											<Checkbox 
												label={`${user.firstName} ${user.phone ? `- ${user.phone}` : ''}`} 
												register={register} 
												name={`users[${user.id}]`} 
												email={user.email}
											/>
										</div>
									</div>
								)}
							</div>
							<div className="error">{usersError}</div>
						</div>
					</div>

					<button type="submit" className="button">Send notification</button>
					<div className="error">{message}</div>
				</form>
			</div>
		</div>
	)
}

